import styled, { css } from 'styled-components';

import { IconChevronRightCircle, mediaMixin, token } from '@zillow/constellation';

export const StyledIconChevronRightCircle = styled(IconChevronRightCircle)`
  color: ${token('colors.brand')};
  flex-grow: 1;
  position: relative;
  bottom: -2px;
  left: 8px;

  ${mediaMixin(
    'lg',
    css`
      left: 0px;
    `,
  )}
`;
